/* ヘルプメッセージ, バリデーション */
import React from 'react';
import HelpMessage from '../atoms/HelpMessage';
import ValidMessage from '../atoms/ValidMessage';
var Messages = function (_a) {
    var help_msg = _a.help_msg, valid_msg = _a.valid_msg;
    return (React.createElement(React.Fragment, null,
        React.createElement(HelpMessage, { help_msg: help_msg }),
        React.createElement(ValidMessage, { message: valid_msg })));
};
export default Messages;
